import { render, staticRenderFns } from "./FrkButton.vue?vue&type=template&id=fdb483fa&"
import script from "./FrkButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FrkButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports